import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import router from './router'

Vue.config.productionTip = false

import '@/assets/icomoon/style.css'
import '@/assets/css/Main.css'

import Notifications from 'vue-notification'
Vue.use(Notifications)

import VueYouTubeEmbed from 'vue-youtube-embed'
Vue.use(VueYouTubeEmbed)

import VueFilterDateFormat from 'vue-filter-date-format'
Vue.use(VueFilterDateFormat)

var VueCookie = require('vue-cookie')
Vue.use(VueCookie)

import Global from './Global.vue'
Vue.prototype.$Global = Global

import { CONFIG } from '../config'
import Qs from 'qs'
Vue.prototype.Qs = Qs
import axios from 'axios'
Vue.prototype.$http = axios

// Add a request interceptor
axios.interceptors.request.use(function (config) {
    // Do something before request is sent
    config.headers["Access-Control-Allow-Origin"]="*"
    // console.log("axios.interceptors = ",config.headers['Content-Type'])
    
    if(!config.headers['Content-Type']){
      config.headers['Content-Type']='application/x-www-form-urlencoded'  
    }
    if(config.url.includes("TrustLink")) {
      //config.url = 'https://testtrustlink.hitrust.com.tw' + config.url;
      config.url = CONFIG.API_URL+config.url;
    } else {
    if(!config.url.includes("erpMemberLogin") && !config.url.includes("common")) {
      config.headers["token"]= sessionStorage.getItem('cerpsMemberToken')
    }
    config.url = CONFIG.API_URL+config.url;
	}
	
    return config;
  }, function (error) {
    // Do something with request error
    return Promise.reject(error);
  });

// Add a response interceptor
axios.interceptors.response.use(function (response) {
    // Do something with response data
	if (response.data.code == '990') {
	  alert(response.data.msg)
      location.href = location.origin+location.pathname + '#/login'
	}
    return response;
  }, function (error) {
    // Do something with response error
    if(error&&error.response&&error.response.data.State=="999"){
      //alert(error.response.data.ErrorMessage)
	  if(!location.hash.includes("login")) {
		alert("使用者連線逾時或尚未登入, 請重新登入")
	  }
      location.href = location.origin+location.pathname + '#/login'
    }
    return Promise.reject(error);
  });

Vue.prototype.$system = {
  system:false,
  operation:false,
  dean:false
}

new Vue({
  vuetify,
  router,
  render: h => h(App)
}).$mount('#app')
